// src/utils/viewport.js
export function initViewportVars() {
  const root = document.documentElement;

  let raf = 0;
  const setNow = () => {
 const vv = window.visualViewport;

// Detect pinch-zoom: scale > 1 means user zoomed in
const scale = vv?.scale ?? 1;

// Use vv.height only when NOT pinch-zooming.
// During pinch-zoom, vv.height changes a lot and breaks layout.
// Fallback to window.innerHeight (more stable) while zoomed.
const h =
  scale !== 1
    ? window.innerHeight
    : (vv?.height || window.innerHeight);

root.style.setProperty("--vh", `${h * 0.01}px`);
root.style.setProperty("--app-h", `${h}px`);

  };

  const set = () => {
    if (raf) cancelAnimationFrame(raf);
    raf = requestAnimationFrame(() => {
      raf = 0;
      setNow();
    });
  };

  setNow();

  // resize covers: orientation + address bar changes + keyboard changes (mostly)
  window.addEventListener("resize", set, { passive: true });
  window.visualViewport?.addEventListener("resize", set, { passive: true });
  window.visualViewport?.addEventListener("scroll", set, { passive: true });

  return () => {
    if (raf) cancelAnimationFrame(raf);
    window.removeEventListener("resize", set);
    window.visualViewport?.removeEventListener("resize", set);
    window.visualViewport?.removeEventListener("scroll", set);
  };
}